import { gsapSingleton, scrollTriggerSingleton, splitTextSingleton } from "../gsap";
import $ from 'jquery';
import Component from '../models/Component';

const gsap = gsapSingleton();
const ScrollTrigger = scrollTriggerSingleton();
const SplitText = splitTextSingleton();

gsap.registerPlugin(ScrollTrigger, SplitText);

export default class TitleEntrance extends Component {
  constructor(element, context) {
    super(element, context);

    $(() => {
      const animatedText = this.element.find('h1');
      const split = new SplitText(animatedText, {
        type: "lines, words, chars"
      });

      const lines = split.lines;
      const chars = split.chars;

      animatedText.removeClass('opacity-0');
      chars.forEach(char => {
        $(char).addClass('h1-char');
      });

      // Aggiungiamo overflow hidden alle linee
      lines.forEach(line => gsap.set(line, { overflow: "hidden" }));

      // Animazione: i caratteri salgono dal basso
      gsap.fromTo(
        chars,
        { yPercent: 100 },
        {
          yPercent: 0,
          duration: 0.8,
          stagger: 0.03,
          ease: "power3.out",
          /*
          scrollTrigger: {
            trigger: animatedText,
            start: "top 80%",
            once: true,
          },
          */
        }
      );
    });
  }
}

